// src/components/layouts/OnboardingLayout.tsx
import React from 'react';
import ProgressBar from '@/components/onboarding/ProgressBar';
import { useBranding } from './../../contexts/BrandingContext.tsx';
interface OnboardingLayoutProps {
  children: React.ReactNode;
  currentStep: number;
  totalSteps: number;
}

const OnboardingLayout: React.FC<OnboardingLayoutProps> = ({ children, currentStep, totalSteps }) => {
  const { branding } = useBranding();
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 dark:from-gray-900 dark:to-slate-800 flex flex-col items-center justify-center p-4">
       {/* Logo is now handled in Step1Welcome */}

      <div className="w-full max-w-2xl bg-white dark:bg-gray-800 rounded-xl shadow-2xl overflow-hidden">
        <div className="p-6 border-b border-gray-200 dark:border-gray-700">
             {currentStep < totalSteps && (
                 <ProgressBar currentStep={currentStep} totalSteps={totalSteps} />
             )}
        </div>
        <div className="p-8 sm:p-10">
          {children}
        </div>
      </div>

      {/* Updated Support Link */}
      <p className="text-center text-xs text-gray-500 dark:text-gray-400 mt-6">
        Need help? <a href={`mailto:${branding.fromEmail}`} className="text-blue-600 hover:underline">Contact Support</a> {/* Changed to mailto: */}
      </p>
    </div>
  );
};

export default OnboardingLayout;